import { render, staticRenderFns } from "./KpiAdmin.vue?vue&type=template&id=4072ea98&scoped=true"
import script from "./KpiAdmin.vue?vue&type=script&lang=js"
export * from "./KpiAdmin.vue?vue&type=script&lang=js"
import style0 from "./KpiAdmin.vue?vue&type=style&index=0&id=4072ea98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072ea98",
  null
  
)

export default component.exports